module.exports = __webpack_public_path__ + "assets/img/2778f20876ffb2886532fae67c1579cd.png";